module.exports = __webpack_public_path__ + "static/media/rm_06-21.208803d2.png";